var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H4a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4ZM6.5 4.2c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3Zm3.9 9.5-.4.1H3l-.4-.1-.1-.4c.2-1.7 1.5-3 3.2-3.2h1.6c1.7.2 3 1.5 3.2 3.2l-.1.4Zm6.6 0h-2a.8.8 0 0 1-.8-.7c0-.4.4-.8.8-.8h2c.4 0 .8.4.8.8s-.4.8-.8.8Zm0-4h-4a.8.8 0 0 1-.8-.7c0-.4.4-.8.8-.8h4c.4 0 .8.4.8.8s-.4.8-.8.8Zm0-4h-5a.8.8 0 0 1-.8-.7c0-.4.4-.8.8-.8h5c.4 0 .8.4.8.8s-.4.8-.8.8Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteList);
export default __webpack_public_path__ + "static/media/inviteList.836635bcc55ccc4a673c31622d46915d.svg";
export { ForwardRef as ReactComponent };